import React from 'react'
import PropTypes from 'prop-types'
import { Helmet as ReactHelmet } from 'react-helmet'

export const Helmet = ({ title }) => <ReactHelmet title={`${title} - hoopla Vendor`} />

Helmet.propTypes = {
  title: PropTypes.string.isRequired,
}
